import React, { useEffect, useState, useRef, useContext, useCallback } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import PRODUCT_API from '../../../utilities/api/product'
import Slider from 'react-rangeslider'

import {
  getIconSlugByName,
  removeSpinner,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from '../../../utilities/function/apiResponse'

import {
  getAttributes
} from '../../../utilities/function/configuration'

import {
  getPriceByBillingCycleName,
  getCycle
} from '../../../utilities/function/billingCycle'

import {renderSaveMore} from '../webhosting'
import {
  ANNUALLY,
  ConnectorContext,
  MONTHLY,
  UPDATE_ADDONS,
  UPDATE_BILLING_CYCLE,
  UPDATE_CONFIG_OPTIONS
} from '../index'
import { useDispatch, useSelector } from 'react-redux'
import { updateConfig } from '../../../app/action'
import Tooltip from '../../shared/tooltip'

export const PRESET_CLASSNAME = 'of-customhosting-preset-connector'
export const RESOURCE_CLASSNAME = 'of-customhosting-resource-connector'

const CustomHostingSlider = (props) => {
  const sliderRef = useRef(null)
  const { config } = props
  const { state, dispatch } = useContext(ConnectorContext)
  const prevConfigOptions = useRef()
  const getInitialValue = useCallback(() => {
    let selectedIndex = 0
    if (state && state.customHosting && state.customHosting.configOptions) {
      const selectedConfig = state.customHosting.configOptions.find(item => item.config_id === config.id)
      if (config && config.options && config.options.length > 0) {
        config.options.forEach((item, index) => {
          if (item.id === selectedConfig.option_id) {
            selectedIndex = index
          }
        })
      }
    }
    return selectedIndex
  }, [state, config])
  const getCurrentConfigOptions = useCallback(()=>{
    let selectedIndex = 0
    if(state && state.customHosting && state.customHosting.configOptions){
      const selectedConfig = state.customHosting.configOptions.find(item => item.config_id === config.id)
      if (config && config.options && config.options.length > 0) {
        config.options.forEach((item, index) => {
          if (item.id === selectedConfig.option_id) {
            selectedIndex = index
          }
        })
      }
      return selectedIndex
    }
  },[state,config])
  const [value, setValue] = useState(0)
  const initFlag = useRef(false)
  useEffect(() => {
    if (!initFlag.current) {
      if (getInitialValue() > 0) {
        setValue(getInitialValue())
        initFlag.current = true
      }
    }

  }, [getInitialValue])

  useEffect(() => {
    if(prevConfigOptions.current !== state.customHosting.configOptions){
      setValue(getCurrentConfigOptions())
      prevConfigOptions.current = state.customHosting.configOptions
    }

  }, [getCurrentConfigOptions,prevConfigOptions,state])


  const getMax = () => {
    if (config) {
      const { options } = config
      if (options && options.length) {
        return options.length - 1
      }
    }

    return 0
  }
  const getLabels = () => {
    let labels = {}
    if (config) {
      const { options } = config
      if (options && options.length) {
        options.forEach((item, index) => {
          labels[index] = item.name
        })
      }
    }
    return labels
  }
  const getConfigValue = () => {
    if (config && config.options && config.options.length) {
      const { options } = config
      const selectedOption = options.find((item, index) => index === value)
      return selectedOption && selectedOption.name ? selectedOption.name : null
    }
    return null
  }
  const getSelectedOption = () => {
    if (config && config.options && config.options.length) {
      const { options } = config
      const selectedOption = options.find((item, index) => index === value)
      return selectedOption
    }
    return null
  }
  const getPrice = () => {
    if (state && state.customHosting) {
      const { billingCycle } = state.customHosting
      const selected = getSelectedOption()
      if (billingCycle && selected.price && selected.price.length > 0) {
        return selected.price.find(item => item.name === billingCycle)
      }
      return null
    }
  }
  const renderPrice = () => {
    const selectedPrice = getPrice()
    const cycle = selectedPrice && getCycle(selectedPrice.name) ? getCycle(selectedPrice.name) : null
    if(cycle){
      return (
        <div className={'of-slider-connector__slider-price'}>
          <div className={'of-slider-connector__slider-price__value'}>${selectedPrice.price}</div>
          <div className={'of-slider-connector__slider-price__cycle'}>{cycle}</div>
        </div>
      )
    }
    return (<></>)
  }
  const sliderOnChange = useCallback(() => {
    const getOption = () => {
      if (config && config.options && config.options.length) {
        return (config.options.find((item, index) => index === value))
      }
      return null
    }
    if (state && state.customHosting && state.customHosting.configOptions) {
      let newConfigOptions = state.customHosting.configOptions
      if (newConfigOptions && newConfigOptions.length) {
        const option = getOption()
        newConfigOptions.forEach((item, index) => {
          if (item.config_id === config.id) {
            newConfigOptions[index].option_id = option.id
          }
        })
        dispatch({
          type: UPDATE_CONFIG_OPTIONS,
          configOptions: newConfigOptions,
          productType: 'customHosting',
          preset: 'custom'
        })
      }
    }
  }, [state, dispatch, value, config])
  if(config){
    const{name,description} = config
    return (
      <div className={'of-slider-connector'}>
        <div className={'of-slider-connector__wrapper'}>
          <div className={'of-slider-connector__heading'}>
            <div className={'of-slider-connector__config-value'}>
              {getConfigValue()}
            </div>
            <div className={'of-slider-connector__config-name'}>
              {name}
            </div>
            <Tooltip className={'of-slider-connector__tooltip'} description={description} />
          </div>
          <div className={'of-slider-connector__slider-wrapper'}>
            <Slider
              className={'of-slider-connector-slider'}
              min={0}
              max={getMax()}
              value={value}
              tooltip={false}
              onChange={(val) => {
                setValue(val)
              }}
              onChangeComplete={sliderOnChange}
              ref={sliderRef}
              labels={getLabels()}
            />
          </div>
        </div>
        {renderPrice()}
      </div>
    )
  }
  return (<></>)
}
CustomHostingSlider.propTypes = {
  config: PropTypes.any
}

const initCustomHosting = (data, dispatch, billingCycleName) => {
  if (data && Array.isArray(data) && data.length) {
    const product = data[0]
    if (product && product.attributes) {
      const { config_options, addons } = product.attributes
      if (config_options && config_options.length) {
        const newConfigOptions = new Array(config_options.length)
        config_options.forEach((config,index) => {
          if (config.name === 'Disk Space') {
            if (config.options && config.options.length > 0) {
              const selectedOption = config.options.find(item => item.name === '10GB')
              newConfigOptions[index]={
                config_id: config.id,
                option_id: selectedOption.id
              }
            }
          }
          if (config.name === 'Memory') {
            if (config.options && config.options.length > 0) {
              const selectedOption = config.options.find(item => item.name === '4GB')
              newConfigOptions[index]={
                config_id: config.id,
                option_id: selectedOption.id
              }
            }
          }
          if (config.name === 'CPU') {
            if (config.options && config.options.length > 0) {
              const selectedOption = config.options.find(item => item.name === '400%')
              newConfigOptions[index]={
                config_id: config.id,
                option_id: selectedOption.id
              }
            }
          }
        })
        if (newConfigOptions && newConfigOptions.length > 0) {
          dispatch({
            type: UPDATE_CONFIG_OPTIONS,
            productType: 'customHosting',
            configOptions: newConfigOptions,
            preset: 'custom'
          })
        }
      }
      if (addons && addons.length) {
        let newAddons = []
        addons.forEach((item) => {
          const { price } = item
          const selectedPrice = getPriceByBillingCycleName(price, billingCycleName)
          if (selectedPrice && selectedPrice.price === '0.00') {
            newAddons.push({
              id: item.id,
              billing_cycle_id: selectedPrice.billing_cycle_id
            })
          }
        })
        dispatch({
          type: UPDATE_ADDONS,
          productType: 'customHosting',
          addons: newAddons
        })
      }
    }
  }
}

export const CustomHostingResources = (props) => {
  const configurations = useSelector(state=>state.app.configurations)
  const appDispatch = useDispatch();
  const { heading, pid, container, router,homepage,presets,promo } = props
  const { history } = router
  const { state, dispatch } = useContext(ConnectorContext)
  const [requestResources, setRequestResources] = useState({})
  const prevBillingCycle = useRef(null)
  const getCurrentBillingCycle = useCallback(() => {
    if (state && state.customHosting) {
      const { billingCycle } = state.customHosting
      if (billingCycle) {
        return billingCycle
      }
    }
    return null
  }, [state])
  const getCurrentPresetName = useCallback(() => {
    if (state && state.customHosting && state.customHosting.preset) {
      const { preset } = state.customHosting
      if (preset) {
        return preset
      }
    }
    return null
  }, [state])




  useEffect(() => {
    if (requestResources.status === undefined && pid) {
      setRequestResources({
        ...requestResources,
        status: 'loading'
      })
      PRODUCT_API.getConnectorProduct(pid).then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        setRequestResources({
          ...requestResources,
          status: 'success',
          data
        })
        initCustomHosting(data, dispatch, getCurrentBillingCycle())
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        setRequestResources({
          ...requestResources,
          status: 'error',
          error
        })
      })
    }
  }, [requestResources, pid, dispatch,getCurrentBillingCycle])


  //hook addon changes
  useEffect(() => {
    if (state && state.customHosting && state.customHosting.addons && state.customHosting.billingCycle
      && requestResources.status === 'success' && requestResources.data && requestResources.data.length) {
      if (prevBillingCycle.current !== state.customHosting.billingCycle) {
        let newAddons = state.customHosting.addons
        if (newAddons && newAddons.length) {
          const product = requestResources.data[0]
          if (product && product.attributes) {
            const { price } = product.attributes
            const selectedPrice = getPriceByBillingCycleName(price, getCurrentBillingCycle())
            newAddons.forEach((item, index) => {
              newAddons[index].billing_cycle_id = selectedPrice.billing_cycle_id
            })
          }
          dispatch({
            type: UPDATE_ADDONS,
            productType: 'customHosting',
            addons: newAddons
          })
        }
        prevBillingCycle.current = state.customHosting.billingCycle
      }
    }
  }, [getCurrentBillingCycle, dispatch, requestResources, state])
  useEffect(()=>{
    removeSpinner(container)
  },[container])

  const renderPresetHeading = () => {
    if (homepage) {
      return (
        <div className={`${PRESET_CLASSNAME}__heading`}>
          <div className={`${PRESET_CLASSNAME}__heading-wrapper`}>
            <div className={`${PRESET_CLASSNAME}__heading-line`}/>
            <div className={`${PRESET_CLASSNAME}__heading-text`}>Recommended Preset Plans</div>
          </div>
        </div>
      )
    }
    return (<></>)
  }
  const renderPresetList = () => {
    if (presets && JSON.parse(presets)) {
      const presetList = JSON.parse(presets)
      const renderList = () => {
        if (presetList && presetList.length) {
          return presetList.map((item, index) => {
            const { name, price } = item
            const itemOnClick = (()=>{
              if(state && state.customHosting && state.customHosting.configOptions
                && requestResources.status==="success" && requestResources.data
                && requestResources.data.length > 0){
                const product = requestResources.data[0]
                const {memory,storage,cpu} = item
                if(memory && cpu && storage && product && product.attributes && product.attributes.config_options && product.attributes.config_options.length){
                  const newConfigOptions = new Array(product.attributes.config_options.length)
                  const memoryConfig = product.attributes.config_options.find(i=>i.name==="Memory")
                  const memoryOption = memoryConfig.options.find((i,index)=>index===parseInt(memory))
                  const cpuConfig = product.attributes.config_options.find(i=>i.name==="CPU")
                  const cpuOption = cpuConfig.options.find((i,index)=>index===parseInt(cpu))
                  const diskConfig = product.attributes.config_options.find(i=>i.name==="Disk Space")
                  const diskOption = diskConfig.options.find((i,index)=>index===parseInt(storage))
                  product.attributes.config_options.forEach((configoption,index)=>{
                    if(configoption.name==='Memory'){
                      newConfigOptions[index] = {
                        config_id: memoryConfig.id,
                        option_id: memoryOption.id
                      }
                    }
                    if(configoption.name==='CPU'){
                      newConfigOptions[index] = {
                        config_id: cpuConfig.id,
                        option_id: cpuOption.id
                      }
                    }
                    if(configoption.name==='Disk Space'){
                      newConfigOptions[index] = {
                        config_id: diskConfig.id,
                        option_id: diskOption.id
                      }
                    }
                  })
                  if(newConfigOptions && newConfigOptions.length > 0){
                    dispatch({
                      type: UPDATE_CONFIG_OPTIONS,
                      productType: 'customHosting',
                      configOptions: newConfigOptions,
                      preset: item.name
                    })
                  }
                }
              }
            })
            const isSelected = () =>{
                if(getCurrentPresetName()===name){
                  return true
                }
                return false
            }
            return (
              <li onClick={itemOnClick} key={index} className={`${PRESET_CLASSNAME}-item${isSelected()?` ${PRESET_CLASSNAME}-item--selected`:''}`}>
                <div className={`${PRESET_CLASSNAME}-item__radio`}></div>
                <div className={`${PRESET_CLASSNAME}-item__details`}>
                  <div className={`${PRESET_CLASSNAME}-item__heading`}>{name}</div>
                  <div className={`${PRESET_CLASSNAME}-item__description`}>from ${price}/mo</div>
                </div>
              </li>
            )
          })
        }
      }
      return (
        <ul className={`${PRESET_CLASSNAME}__list`}>
          <li onClick={()=>{
            if(state && state.customHosting && state.customHosting.configOptions){
              dispatch({
                type: UPDATE_CONFIG_OPTIONS,
                productType: 'customHosting',
                configOptions: state.customHosting.configOptions,
                preset: 'custom'
              })
            }
          }} className={`${PRESET_CLASSNAME}-item${getCurrentPresetName()==='custom'?` ${PRESET_CLASSNAME}-item--selected`:''}`}>
            <div className={`${PRESET_CLASSNAME}-item__radio`}></div>
            <div className={`${PRESET_CLASSNAME}-item__details`}>
              <div className={`${PRESET_CLASSNAME}-item__heading`}>Build a custom plan</div>
            </div>
          </li>
          {renderList()}
        </ul>
      )
    }
    return (<></>)
  }
  const renderConfigOptions = () => {
    if (requestResources && requestResources.status === 'success' && requestResources.data && requestResources.data.length > 0) {
      const customHostingProduct = requestResources.data[0]
      if (customHostingProduct && customHostingProduct.attributes) {
        const { config_options } = customHostingProduct.attributes
        if (config_options && config_options.length) {
          const renderConfigList = () => {
            if (config_options && config_options.length) {
              return config_options.map((config, index) => {
                return (<CustomHostingSlider key={index} config={config}/>)
              })
            }
          }
          return (
            <div className={`${RESOURCE_CLASSNAME}__config-options`}>
              {renderConfigList()}
            </div>
          )
        }
      }
    }
  }
  const renderAddons = () => {
    const getAddons = () => {
      if (requestResources && requestResources.status === 'success' && requestResources.data && requestResources.data.length > 0) {
        const product = requestResources.data[0]
        if (product && product.attributes) {
          const { addons } = product.attributes
          if (addons && addons.length && addons.length > 0) {
            return addons
          }
        }
      }
    }
    const addonList = getAddons()
    const renderAddonList = () => {
      return addonList.map((item, index) => {
        if(item && item.id && item.attributes){
          const { name, description, price } = item.attributes
          const isAddonSelected = () =>{
            if(state && state.customHosting && state.customHosting.addons && state.customHosting.addons.length > 0){
              return state.customHosting.addons.find(i=>parseInt(item.id)===parseInt(i.id))
            }
            return false
          }
          const currentBillingCycle = getCurrentBillingCycle()
          const selectedPrice = getPriceByBillingCycleName(price, currentBillingCycle)
          const isIncluded = () =>{
            if(selectedPrice && selectedPrice.price === '0.00'){
              return true
            }
            return false
          }
          const renderCTA = () => {
            if (isIncluded()) {
              return (
                <div className={`${RESOURCE_CLASSNAME}__addons-cta`}>
                  <div
                    className={`${RESOURCE_CLASSNAME}__addons-price ${RESOURCE_CLASSNAME}__addons-price--free`}>Included
                    Free
                  </div>
                </div>
              )
            }
            const cycle = getCycle(currentBillingCycle)

            const renderCheckbox = () => {
              if(isAddonSelected()){
                return(
                  <div className={`${RESOURCE_CLASSNAME}__addons-add-checkbox ${RESOURCE_CLASSNAME}__addons-add-checkbox--selected`}>
                    <i className={'icon icon-of-tick-solid'} />
                  </div>
                )
              }
              return (
                <div className={`${RESOURCE_CLASSNAME}__addons-add-checkbox`}/>
              )
            }
            if(selectedPrice){
              return (
                <div className={`${RESOURCE_CLASSNAME}__addons-cta`}>
                  <div className={`${RESOURCE_CLASSNAME}__addons-cta-wrapper`}>
                    <div className={`${RESOURCE_CLASSNAME}__addons-price`}>${selectedPrice.price}<span>{cycle}</span></div>
                    <div className={`${RESOURCE_CLASSNAME}__addons-add`} >
                      {renderCheckbox()}
                      <label className={`${RESOURCE_CLASSNAME}__addons-add-label`}>Add to plan</label>
                    </div>
                  </div>
                </div>
              )
            }
            return (<></>)
          }
          const addonOnClick = () =>{
            let newAddons = state.customHosting.addons
            const getSelectedPrice = getPriceByBillingCycleName(price,currentBillingCycle)
            if(newAddons && newAddons.length > 0){
              const isSelected = newAddons.find(i=>parseInt(i.id)===parseInt(item.id))
              if(isSelected){
                if(getSelectedPrice.price !== "0.00"){
                  newAddons = newAddons.filter(i=>i.id!==item.id)
                }
              }else{
                newAddons.push({
                  id: item.id,
                  billing_cycle_id: getSelectedPrice.billing_cycle_id
                })
              }
            }else{
              newAddons.push({
                id: item.id,
                billing_cycle_id: getSelectedPrice.billing_cycle_id
              })
            }
            dispatch({
              type: UPDATE_ADDONS,
              productType: 'customHosting',
              addons : newAddons
            })
          }
          const slug = getIconSlugByName(name)
          return (
            <div key={index} onClick={addonOnClick}
                 className={`${RESOURCE_CLASSNAME}__addons-item${isIncluded() ? ` ${RESOURCE_CLASSNAME}__addons-item--free` : ''}${isAddonSelected()?` ${RESOURCE_CLASSNAME}__addons-item--selected` :''}`}>
              <div className={`${RESOURCE_CLASSNAME}__addons-icon icon-of-${slug}`}></div>
              <div className={`${RESOURCE_CLASSNAME}__addons-details`}>
                <div className={`${RESOURCE_CLASSNAME}__addons-name`}>
                  {name}
                </div>
                <div className={`${RESOURCE_CLASSNAME}__addons-description`}>
                  {description}
                </div>
              </div>
              {renderCTA()}
            </div>
          )
        }
        return (<div key={index}></div>)
      })
    }
    if (addonList && addonList.length && getCurrentBillingCycle()) {
      return (<div className={`${RESOURCE_CLASSNAME}__addon`}>
        {renderAddonList()}
      </div>)
    }
    return (<></>)
  }
  const renderTotalSection = () => {
    if (requestResources.status === 'success' && requestResources.data) {
      const isChecked = (cycle) => {
        if (cycle === getCurrentBillingCycle()) {
          return true
        }
        return false
      }
      const onSelect = (value) => {
        dispatch({
          type: UPDATE_BILLING_CYCLE,
          cycle: value,
          productType: 'customHosting'
        })
      }
      const buttonOnClick = e => {
        e.preventDefault()
        if(requestResources.data && requestResources.data.length > 0){
          const product = requestResources.data[0]
          if(product && product.attributes){
            const {price} = product.attributes
            const selectedPrice = getPriceByBillingCycleName(price,getCurrentBillingCycle())
            if(selectedPrice){
              updateConfig(configurations,pid,{
                billing_cycle_id: selectedPrice.billing_cycle_id,
                config: state.customHosting.configOptions,
                addons: state.customHosting.addons,
                step: 0
              },appDispatch)
            }
            window.setTimeout(()=>{
              history.push(`${history.location.pathname}?a=add&pid=${pid}${promo?'&promo='+promo:''}`)
            },300)
          }
        }
      }
      const renderTotalCost = () => {
        if(state && state.customHosting && requestResources && requestResources.status==="success" && requestResources.data && requestResources.data.length){
          const product = requestResources.data[0]
          let total = 0
          const billingCycle = state.customHosting.billingCycle
          const getTotalConfig = () =>{
            let configTotal = 0
            if(state.customHosting.configOptions && state.customHosting.configOptions.length > 0){
              const options = state.customHosting.configOptions
              if(options && options.length && product && product.attributes && product.attributes.config_options){
                options.forEach((item)=>{
                  const config = product.attributes.config_options.find(i=>i.id===item.config_id)
                  if(config && config.options && config.options.length){
                    const option = config.options.find(i=>i.id===item.option_id)
                    const selectedPrice = getPriceByBillingCycleName(option.price,billingCycle)
                    if(selectedPrice && selectedPrice.price && parseFloat(selectedPrice.price)){
                      configTotal += parseFloat(selectedPrice.price)
                    }
                  }
                })
              }
            }
            return configTotal
          }
          total += getTotalConfig()
          const getTotalAddon = () => {
            let addonTotal = 0
            if(state.customHosting.addons && state.customHosting.addons.length > 0){
              const addons = state.customHosting.addons
              if(addons && addons.length && product && product.attributes && product.attributes.addons){
                addons.forEach((item)=>{
                  const addonItem = product.attributes.addons.find(i=>i.id===item.id)
                  if(addonItem && getAttributes(addonItem)){
                    const {price} = getAttributes(addonItem)
                    if(price){
                      const selectedPrice = getPriceByBillingCycleName(price,billingCycle)
                      if(selectedPrice && selectedPrice.price && parseFloat(selectedPrice.price)){
                        addonTotal += parseFloat(selectedPrice.price)
                      }
                    }
                  }
                })
              }
            }
            return addonTotal
          }
          total += getTotalAddon()
          return (  <div className={`${RESOURCE_CLASSNAME}__cta-cost`}>
              <div className={`${RESOURCE_CLASSNAME}__cta-cost-label`}>Total Cost</div>
              <div className={`${RESOURCE_CLASSNAME}__cta-cost-value`}>${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}<strong>{getCycle(billingCycle)}</strong></div>
            </div>
          )
        }
        return (<></>)
      }
      return (
        <div className={`${RESOURCE_CLASSNAME}__total`}>
          <div className={`${RESOURCE_CLASSNAME}__total-billing-cycle ${RESOURCE_CLASSNAME}-total-bc`}>
            <ul className={`${RESOURCE_CLASSNAME}__total-list ${RESOURCE_CLASSNAME}-total-bc__list`}>
              <li className={`${RESOURCE_CLASSNAME}-total-bc__item`} onClick={(e) => {
                e.preventDefault()
                onSelect(MONTHLY)
              }}>
                <div className={`${RESOURCE_CLASSNAME}-total-bc__circle${isChecked(MONTHLY)?` selected`:''}`} />
                <label className={`${RESOURCE_CLASSNAME}-total-bc__label`}>Pay Monthly</label>
              </li>
              <li className={`${RESOURCE_CLASSNAME}-total-bc__item`} onClick={(e) => {
                e.preventDefault()
                onSelect(ANNUALLY)
              }}>
                {renderSaveMore(ANNUALLY)}
                <div className={`${RESOURCE_CLASSNAME}-total-bc__circle${isChecked(ANNUALLY)?` selected`:''}`} />
                <label className={`${RESOURCE_CLASSNAME}-total-bc__label`}>Pay Yearly</label>
              </li>
            </ul>
          </div>
          <div className={`${RESOURCE_CLASSNAME}__cta`}>
            {renderTotalCost()}
            <button className={`${RESOURCE_CLASSNAME}__cta-button`} onClick={buttonOnClick}>
              <span>Add to cart</span>
              <i className='icon icon-of-add-basket'/>
            </button>
          </div>
        </div>
      )
    }
    return (<></>)
  }
  return ReactDOM.createPortal(<>
    <div className={PRESET_CLASSNAME}>
      {renderPresetHeading()}
      {renderPresetList()}
    </div>

    <div className={`${RESOURCE_CLASSNAME}`}>
    <div className={`${RESOURCE_CLASSNAME}__wrapper`}>
      <div className={`${RESOURCE_CLASSNAME}__heading`}>{heading}</div>
      {renderConfigOptions()}
      {renderAddons()}
      {renderTotalSection()}
    </div>
  </div></>, container)
}
CustomHostingResources.propTypes = {
  heading: PropTypes.any,
  pid: PropTypes.any,
  container: PropTypes.any
}

export const RenderCustomHostingResourcesConnector = (props) => {
  const { router } = props
  const domlist = Array.from(document.querySelectorAll(`.${RESOURCE_CLASSNAME}`))
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const pid = el.getAttribute('data-pid')
      const heading = el.getAttribute('data-heading')
      const presets = el.getAttribute('data-presets')
      const homepage =  el.getAttribute('data-homepage')
      const promo =  el.getAttribute('data-promo')
      return (<CustomHostingResources
        router={router}
        key={index}
        container={el}
        pid={pid}
        heading={heading}
        presets={presets}
        homepage={homepage}
        promo={promo}
      />)
    })
  }
  return (<></>)
}

RenderCustomHostingResourcesConnector.propTypes = {
  router: PropTypes.any
}